import { IRegion } from '../../types/regions';

export const getRegionsById = (regions: IRegion[]) => {
  const regionsById = new Map<number, IRegion>();

  regions.forEach((region: IRegion) => {
    regionsById.set(region.id, region);
  });

  return regionsById;
};
